export default "__VITE_ASSET__zNHix22s__"